/**
 * Type guard to check if an error is an Apollo-like error.
 * Apollo Client errors can have graphQLErrors, protocolErrors, clientErrors, or networkError properties.
 */
type ApolloLikeError = {
  graphQLErrors?: readonly unknown[];
  protocolErrors?: readonly unknown[];
  clientErrors?: readonly Error[];
  networkError?: unknown;
};

export const isApolloLikeError = (error: unknown): error is ApolloLikeError => {
  if (typeof error !== "object" || error === null) return false;

  const e = error as ApolloLikeError;

  const hasGraphQLErrors = Array.isArray(e.graphQLErrors);
  const hasProtocolErrors = Array.isArray(e.protocolErrors);
  const hasClientErrors = Array.isArray(e.clientErrors);
  const hasNetworkError = typeof e.networkError !== "undefined";

  return hasGraphQLErrors || hasProtocolErrors || hasClientErrors || hasNetworkError;
};
